<div class="row" *ngIf="widgetType">
    <div class="col-lg-4">
      <div class="form-group">
        <h3>Twenty Four Hour</h3>
        <input type="checkbox" [(ngModel)]="widget.twentyfour"/>
        <br />
        <label>Font Size</label>
            <select [(ngModel)]="widget.fontSize" class="group-select m-b form-select">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            </select>
      </div>
    </div>
  </div>
  